module.exports = __webpack_public_path__ + "b516acaf263e26fc385f534c0caba2ea.jpg";